










































import {Component, Vue} from 'vue-property-decorator';
import FilterControl from '@/modules/neodash/components/filter-control/filter-control.vue';
import NotificationsButton from '@/components/notifications-button/notifications-button.vue';

import {i18nMixin} from '@/modules/neodash/mixins';
import {FilterService} from '../../services/filterService';
import {NameValue, NameValues, OptionalNameValue} from '../../model/types/interfaces/NameValue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import {listAllSaleTypes} from '../../model/constants/saleType';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {getUrlReportViewer} from '../../model/constants/reportViewer';
import {ReportsReportViewerEnum} from '@/modules/neodash/model/types/enums/reportsReportViewerEnum';
import {ConstantsVirtualArea} from '@/modules/neodash/model/constants/locationType';
import {Getter} from 'vuex-class';
import {GET_LOADING} from '@/store/types';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import ReportViewerContainer
  from '@/modules/neodash/components/report-viewer-container/report-viewer-container.vue';
import PeriodForm from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import {Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
import {GET_PERIOD} from '@/modules/neodash/store/modules/reports/types';
import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'MarketAnalysisLocale',
  components: {
    ReportContainer,
    ReportViewerContainer,
    FilterContainer,
    PageLoader,
    FilterControl,
    NotificationsButton,
    PeriodForm,
    FilterDropDown,
    FilterMultiSelect
  },
})
export default class MarketAnalysisLocale extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  public typeArea: OptionalNameValue = null;
  public idLocale: OptionalNameValue = null;
  public saleType: OptionalNameValue = null;
  public locales: NameValues = [];
  public period: PeriodFormValue = null;

  public url: string = '';
  public labelFilters: IKeyValues = [];

  public locations: NameValues = [];
  public salesTypes = listAllSaleTypes();
  public areaTypes: NameValues = [];
  public cities: NameValues = [];

  @Getter(GET_LOADING)
  loading: boolean;

  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  public created() {
    this.getVirtualAreas();
  }

  public get limits(): Period {
    return this.getPeriod(ReportEnum.MarketAnalysisLocale);
  }

  public get isFreeArea(): boolean {
    if (!this.typeArea)
      return false;

    return this.typeArea.value === ConstantsVirtualArea.idFreeArea;
  }

  public updateLabelFilters(): void {
    const {saleType, isFreeArea, translate, idLocale, typeArea, period} = this;

    if (!period || !saleType || !typeArea || !idLocale)
      return;

    const locationLabel: string = isFreeArea ? this.getLabelFreeAreaLocation() : `${typeArea.name} - ${idLocale.name}`;

    this.labelFilters = [
      {text: translate('Common.SaleType'), value: saleType.name},
      {text: translate('Common.Locality'), value: locationLabel},
      {text: translate('Common.Period'), value: period.label}
    ];
  }

  private getLabelFreeAreaLocation(): string {
    if (!this.idLocale)
      return '';

    const t = this.translate;
    const formatCityName = x => x.name.replace(', ', ' - ');

    const childrenLocations: string = this.locales.map(formatCityName).join(', ');
    return `${formatCityName(this.idLocale)} ${t('Common.And')} ${t('Filters.LocationType.Bordering')}, ${childrenLocations}`;
  }

  private getVirtualAreas() {
    const {getNameVirtualArea, idFreeArea} = ConstantsVirtualArea;

    const freeArea: NameValue = {
      name: getNameVirtualArea(idFreeArea),
      value: idFreeArea
    };

    FilterService.getVirtualArea()
      .then(x => this.areaTypes = [freeArea, ...x]);
  }

  public get formValid(): boolean {
    const {typeArea, idLocale, saleType, locales} = this;
    return !!typeArea && !!idLocale && !!saleType && (!this.isFreeArea || !!locales.length);
  }

  public showReport() {
    const {typeArea, idLocale, saleType, period, locales} = this;

    if (!period)
      return;

    //todo: refactor to maintain same name of property to all reports
    const params = {
      typeArea: this.isFreeArea ? 0 : typeArea,
      idLocale,
      locales,
      tipoVenda: saleType,
      ...period.value
    };

    traceLogAccess.logAction(ContextEnum.Report, 'Análise de mercado', JSON.stringify(params));
    this.url = getUrlReportViewer(ReportsReportViewerEnum.MarketAnalysis, params);
    this.updateLabelFilters();
  }

  public handleChosenTypeArea(typeArea: NameValue) {
    this.typeArea = typeArea;
    this.idLocale = null;

    if (!this.isFreeArea) {
      FilterService.getLocalityVirtualArea(this.typeArea.value).then(x => this.locations = x);
      return;
    }

    this.locales = [];

    if (!this.cities.length)
      FilterService.listCities().then(x => this.cities = x);
  }
}
